import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Portfolio() {
  const { t } = useTranslation();
  const [activeFilter, setActiveFilter] = useState('all');

  const categories = [
    { id: 'all', name: 'جميع المشاريع' },
    { id: 'consulting', name: 'استشارات' },
    { id: 'tech', name: 'حلول تقنية' },
    { id: 'training', name: 'تدريب' },
    { id: 'marketing', name: 'تسويق' }
  ];

  const projects = [
    {
      id: 1,
      title: 'تطوير استراتيجية شركة تقنية',
      category: 'consulting',
      client: 'شركة التقنية المتقدمة',
      description: 'مشروع تطوير استراتيجية شاملة لشركة تقنية ناشئة',
      image: 'https://public.readdy.ai/ai/img_res/f89db7cb0809dfda29ef61f3c1cfb51b.jpg',
      results: ['زيادة الإيرادات 45%', 'تحسين الكفاءة 60%', 'توسع في 3 أسواق جديدة']
    },
    {
      id: 2,
      title: 'نظام إدارة موارد بشرية',
      category: 'tech',
      client: 'مؤسسة الخدمات الكبرى',
      description: 'تطوير نظام متكامل لإدارة الموارد البشرية',
      image: 'https://readdy.ai/api/search-image?query=modern%20HR%20management%20system%20interface%20on%20computer%20screens%20with%20professional%20workspace%2C%20clean%20minimalist%20background%2C%20corporate%20technology%20environment%2C%20high%20quality%20photography&width=800&height=600&seq=portfolio2&orientation=landscape',
      results: ['توفير 30% من الوقت', 'تحسين رضا الموظفين', 'أتمتة 80% من العمليات']
    },
    {
      id: 3,
      title: 'برنامج تدريب القيادات',
      category: 'training',
      client: 'مجموعة الأعمال الدولية',
      description: 'برنامج تدريبي متخصص لتطوير مهارات القيادة',
      image: 'https://readdy.ai/api/search-image?query=professional%20leadership%20training%20session%20with%20executives%20in%20modern%20conference%20room%2C%20clean%20bright%20background%2C%20corporate%20learning%20environment%2C%20high%20quality%20photography&width=800&height=600&seq=portfolio3&orientation=landscape',
      results: ['تدريب 150 قائد', 'تحسين الأداء 40%', 'تطوير 50 مشروع جديد']
    },
    {
      id: 4,
      title: 'حملة تسويق رقمي متكاملة',
      category: 'marketing',
      client: 'علامة تجارية استهلاكية',
      description: 'استراتيجية تسويق رقمي شاملة عبر جميع القنوات',
      image: 'https://readdy.ai/api/search-image?query=digital%20marketing%20campaign%20with%20social%20media%20analytics%20and%20creative%20content%20displays%2C%20clean%20modern%20background%2C%20professional%20marketing%20workspace%2C%20high%20quality%20photography&width=800&height=600&seq=portfolio4&orientation=landscape',
      results: ['زيادة المبيعات 85%', 'نمو المتابعين 200%', 'تحسين التفاعل 150%']
    },
    {
      id: 5,
      title: 'إعادة هيكلة مؤسسة تعليمية',
      category: 'consulting',
      client: 'مؤسسة التعليم الحديث',
      description: 'مشروع إعادة هيكلة شاملة لتحسين الأداء المؤسسي',
      image: 'https://readdy.ai/api/search-image?query=modern%20educational%20institution%20with%20professional%20staff%20in%20bright%20learning%20environment%2C%20clean%20minimalist%20background%2C%20academic%20corporate%20setting%2C%20high%20quality%20photography&width=800&height=600&seq=portfolio5&orientation=landscape',
      results: ['تحسين الكفاءة 50%', 'زيادة رضا الطلاب', 'تطوير 20 برنامج جديد']
    },
    {
      id: 6,
      title: 'منصة تجارة إلكترونية',
      category: 'tech',
      client: 'متجر الأزياء الفاخرة',
      description: 'تطوير منصة تجارة إلكترونية متكاملة',
      image: 'https://readdy.ai/api/search-image?query=luxury%20fashion%20ecommerce%20platform%20interface%20on%20modern%20devices%20with%20elegant%20product%20displays%2C%20clean%20bright%20background%2C%20professional%20retail%20technology%2C%20high%20quality%20photography&width=800&height=600&seq=portfolio6&orientation=landscape',
      results: ['زيادة المبيعات 120%', 'تحسين تجربة المستخدم', 'توسع دولي']
    },
    {
      id: 7,
      title: 'برنامج تطوير المهارات التقنية',
      category: 'training',
      client: 'شركة البرمجيات الكبرى',
      description: 'برنامج تدريبي مكثف للمطورين والمهندسين',
      image: 'https://readdy.ai/api/search-image?query=technical%20skills%20training%20with%20developers%20working%20on%20computers%20in%20modern%20training%20lab%2C%20clean%20bright%20background%2C%20professional%20tech%20education%20environment%2C%20high%20quality%20photography&width=800&height=600&seq=portfolio7&orientation=landscape',
      results: ['تدريب 200 مطور', 'تحسين الإنتاجية 35%', 'إطلاق 15 منتج جديد']
    },
    {
      id: 8,
      title: 'استراتيجية محتوى رقمي',
      category: 'marketing',
      client: 'شركة الخدمات المالية',
      description: 'تطوير استراتيجية محتوى رقمي شاملة',
      image: 'https://readdy.ai/api/search-image?query=digital%20content%20strategy%20workspace%20with%20creative%20team%20planning%20content%20calendar%2C%20clean%20modern%20background%2C%20professional%20marketing%20environment%2C%20high%20quality%20photography&width=800&height=600&seq=portfolio8&orientation=landscape',
      results: ['زيادة الزيارات 180%', 'تحسين التحويل 90%', 'نمو العملاء 65%']
    },
    {
      id: 9,
      title: 'تحول رقمي لمؤسسة حكومية',
      category: 'consulting',
      client: 'هيئة حكومية',
      description: 'مشروع تحول رقمي شامل لتحسين الخدمات',
      image: 'https://readdy.ai/api/search-image?query=government%20digital%20transformation%20with%20modern%20office%20technology%20and%20professional%20staff%2C%20clean%20bright%20background%2C%20corporate%20public%20sector%20environment%2C%20high%20quality%20photography&width=800&height=600&seq=portfolio9&orientation=landscape',
      results: ['تحسين الخدمات 70%', 'تقليل الوقت 60%', 'رضا المستفيدين 95%']
    }
  ];

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(p => p.category === activeFilter);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center text-white">
            <h1 className="text-5xl font-bold mb-6">سابقة أعمالنا</h1>
            <p className="text-xl text-blue-100 leading-relaxed">
              نفخر بمشاريعنا الناجحة التي ساعدت عملاءنا على تحقيق أهدافهم وتطوير أعمالهم
            </p>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-12 bg-gray-50 sticky top-0 z-40 shadow-md">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap items-center justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveFilter(category.id)}
                className={`px-6 py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  activeFilter === category.id
                    ? 'bg-blue-600 text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-gray-100'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProjects.map((project, index) => (
              <div 
                key={project.id}
                className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="relative h-64 w-full overflow-hidden">
                  <img 
                    src={project.image} 
                    alt={project.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-900/90 to-transparent"></div>
                  <div className="absolute bottom-4 right-4 left-4">
                    <span className="inline-block bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-lg text-sm font-semibold">
                      {categories.find(c => c.id === project.category)?.name}
                    </span>
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-2">{project.title}</h3>
                  <p className="text-sm text-blue-600 mb-3 font-semibold">{project.client}</p>
                  <p className="text-gray-600 leading-relaxed mb-4">{project.description}</p>
                  
                  <div className="space-y-2 mb-6">
                    {project.results.map((result, idx) => (
                      <div key={idx} className="flex items-center gap-2">
                        <i className="ri-check-line text-green-500"></i>
                        <span className="text-sm text-gray-700">{result}</span>
                      </div>
                    ))}
                  </div>
                  
                  <Link 
                    to={`/portfolio/${project.id}`}
                    className="inline-flex items-center gap-2 text-blue-600 font-semibold hover:gap-3 transition-all cursor-pointer"
                  >
                    <span>عرض التفاصيل</span>
                    <i className="ri-arrow-left-line"></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-blue-800">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center text-white">
            <h2 className="text-4xl font-bold mb-6">هل تريد أن يكون مشروعك التالي؟</h2>
            <p className="text-xl text-blue-100 mb-8 leading-relaxed">
              دعنا نساعدك في تحقيق أهدافك وإنجاز مشروع ناجح
            </p>
            <Link 
              to="/request-service"
              className="inline-flex items-center gap-3 bg-white text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              <span>ابدأ مشروعك الآن</span>
              <i className="ri-arrow-left-line"></i>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}